module.exports = __webpack_public_path__ + "img/card-icon-amex.bf33b65d.svg";